import React, {
    createContext,
    useContext,
    useState,
    useCallback
} from 'react';
import { ToastNotification } from './ToastNotification';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
    const [notification, setNotification] = useState(null);

    const showNotification = useCallback((message, type = 'info') => {
        setNotification({
            message,
            type
        });
    }, []);

    const showSuccess = useCallback(
        message => showNotification(message, 'success'),
        [showNotification]
    );

    const showError = useCallback(
        message => showNotification(message, 'error'),
        [showNotification]
    );

    const showWarning = useCallback(
        message => showNotification(message, 'warning'),
        [showNotification]
    );

    const showInfo = useCallback(
        message => showNotification(message, 'info'),
        [showNotification]
    );

    const closeNotification = useCallback(() => {
        setNotification(null);
    }, []);

    return (
        <NotificationContext.Provider
            value={{
                showNotification,
                showSuccess,
                showError,
                showWarning,
                showInfo
            }}
        >
            {children}

            {notification && (
                <ToastNotification
                    message={notification.message}
                    type={notification.type}
                    onClose={closeNotification}
                />
            )}
        </NotificationContext.Provider>
    );
};

export const useNotification = () =>
    useContext(NotificationContext);